export enum ButtonVariations {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  ICON = 'icon',
  SUCCESS = 'success',
  DANGER = 'danger',
  DANGER_SECONDARY = 'danger-secondary',
  LIST_ITEM = 'list-item',
  BANNER = 'banner',
  BANNER_SECONDARY = 'banner-secondary',
}

export interface VariantBackgroundImage {
  image: string;
  horizontalPosition?: string;
  verticalPosition?: string;
  width?: string;
  height?: string;
}

export interface VariantBackgroundColor {
  color: string;
}

export interface ButtonBackgroundProps {
  background: string;
  hoverBackground: string;
}

export interface ButtonTextProps {
  color: string;
  hoverColor: string;
}

interface Image {
  url: string;
}

interface Title {
  text?: string;
  color?: 'dark' | 'light';
}

export type Sizes = 'small' | 'medium' | 'large' | 'xlarge';

export interface SplashProps {
  title: Title;
  subtitle?: Title;
  cta?: {
    text?: string;
    variant?: ButtonVariations.SECONDARY | ButtonVariations.TERTIARY | ButtonVariations.BANNER;
    href?: string;
    fullWidth?: boolean;
  };
  background: Image;
  titleImage?: {
    size?: Sizes;
    image?: Image;
  };
}

export interface LoginVariantProps {
  id: number;
  createdAt?: Date;
  updatedAt?: Date;
  publishedAt?: Date;
  type: string;
  loginTitle?: string;
  onboarding_origin?: string;
  loginSubtitle?: string;
  weight?: string;
  splash?: SplashProps;
  publishDate?: Date;
  removalDate?: Date;
  metadata?: {
    title?: string;
    description?: string;
  };

  footerTextColor?: 'light' | 'dark';
  background?: Partial<Image & VariantBackgroundColor>;
}
